export interface LoginContext {
    username: string;
    password: string;
}
